import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import SelectSearch from 'react-select-search';
import Select from "react-select";
import "react-step-progress-bar/styles.css";
import { ProgressBar } from "react-step-progress-bar";

import PhoneInput from "react-phone-number-input";
import {
    parsePhoneNumber,
    getCountryCallingCode,
    isValidPhoneNumber,
} from "react-phone-number-input";
// import fuzzySearch from "./fuzzySearch";
import { SignupWithoutOtp, ResendOtp, AskOtp, VerifyOtp } from "../../redux/actions/AuthAction";

import { useHistory } from "react-router";
import demologo from "../../assets/demologo.png";
import { useSnackbar } from "react-simple-snackbar";
// import { cities } from "./cities";
import { getDevice } from "../../helpers/PageHelper";
import { AddChildren } from "../../redux/actions/SessionAction";
//
const DemoRegister = ({ subject }) => {
    const history = useHistory()
    const dispatch = useDispatch();
    const [openSnackbar, closeSnackbar] = useSnackbar();
    const [name, setName] = useState("");
    const [city, setCity] = useState("");
    const [email, setEmail] = useState("");
    const [errmsg, setErrmsg] = useState("");
    const [callingCode, setCallingCode] = useState("");
    const [statusCode, setStatusCode] = useState("");
    const [resendOTP, setResendOTP] = useState(false);
    const [isWhatsapp, setIswhatsapp] = useState();
    const [isNumber, setIsnumber] = useState();
    const [isEmail, setIsemail] = useState();

    const [numberOremail, setNumberOrEmail] = useState("");
    const [loder, setLoder] = useState(false);
    const [disabledNumber, setDisabledNumber] = useState(false);
    const [internationalNumber, setInternationalNumber] = useState("");
    const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
    const [grade, setGrade] = useState();

    const [otp, setOtp] = useState();
    const [field, setField] = useState("");

    const { search } = useLocation();
    const subscriptionType = new URLSearchParams(search).get("type");
    const bearAWS = "https://clapngobucket.s3.amazonaws.com/kids/bear.svg";

    useEffect(() => {
        if (window.gtag) {
            window.gtag("event", "conversion", { 'send_to': 'AW-312869085/5K0fCKyDoY0DEN2BmJUB' })
        }
    }, [window.gtag])

    console.log(subscriptionType)
    // const [selectedOption, setSelectedOption] = useState("none");
    // const options = cities.map((city, i) => ({ value: city, label: city }))

    // const handleTypeSelect = e => {
    //     setCity(e.value);
    // };
    // console.log(time_zone)

    useEffect(() => {

        if (internationalNumber) {
            const userPhoneNumber = parsePhoneNumber(internationalNumber);

            if (userPhoneNumber) {
                if (isValidPhoneNumber(userPhoneNumber.number)) {
                    const country_calling_code = getCountryCallingCode(
                        userPhoneNumber.country
                    );

                    setCallingCode("+" + country_calling_code);
                    setNumberOrEmail(
                        internationalNumber.replace("+" + country_calling_code, "")
                    );
                }
            }
        }
    }, [internationalNumber]);

    console.log(numberOremail)
    const signupwithoutotpkids = (e) => {
        console.log("SIGN UP KIDS")
        e.preventDefault();
        console.log("signup")
        setLoder(true);

        const data = {
            name: name,
            phoneNumber: numberOremail,
            email: email,
            city: "default",
            isWebsite: true,
            countryCode: callingCode,
            country: time_zone.country,
            timezone: time_zone.timezone,
            UTMSource: "KIDS_LANDING_PAGE_FACEBOOK",
            source: getDevice()
        };
        const onSucess = (res) => {
            console.log('Parent api success')
            // triggerLead()
            //register kid
            console.log(res)
            var data = {
                avatar: bearAWS,
                name: name,
                country: time_zone.country,
                timezone: time_zone.timezone,
                phoneNumber: numberOremail,
                parentId: res.data.learner._id,
                age: grade+3,
                grade: grade,
            };
            var onSuccess = (response) => {
                setLoder(false);
            console.log(res);

            if (res.status == 200 || res.status == 201) {

                console.log("it works")
                if (subject !== ":component") {
                    localStorage.setItem("SUBJECT", JSON.stringify(subject));
                }

                localStorage.setItem("LOGIN", JSON.stringify("true"));
                localStorage.setItem("ROLE", JSON.stringify("Learner"));
                localStorage.setItem("IS_LOGOUT", true);
                localStorage.setItem("LOGIN", JSON.stringify("true"));
                localStorage.setItem("ROLE", JSON.stringify("Learner"));
                localStorage.setItem("USER", JSON.stringify( response.kidDetails));
                localStorage.setItem("TOKEN", JSON.stringify(response.token));
                localStorage.setItem("IS_LOGOUT", true);
                localStorage.removeItem("STEP");
                localStorage.removeItem("DATA");
                localStorage.removeItem("NAME");
                openSnackbar("successful");

                history.push(`/home-subscription/payment?type=${subscriptionType}`);

                }




            };
            var onError = (error) => {
                console.log("add kid error")
                // setButtonLoader(false);
                // openSnackbar(error);
                setLoder(false);
                setErrmsg(error.response.data.message)
                console.log(error.response.data.message);
            };
            console.log(data);
           dispatch(AddChildren(data, onSuccess, onError, res.data.learner.token));

            //
            // makeToast("success", msg);


        };
        const onError = (res) => {
            //   setField("password");
            setLoder(false);
            setErrmsg("Enter a valid number");
            // openSnackbar("Enter a valid number")

            console.log(res)
        };
        dispatch(SignupWithoutOtp(data, onSucess, onError));
    };

    const signupwithoutotp = (e) => {
        e.preventDefault();
        setLoder(true);

        const data = {
            name: name,
            phoneNumber: numberOremail,
            email: email,
            // city: city,
            isWebsite: true,
            countryCode: callingCode,
            country: time_zone.country,
            timezone: time_zone.timezone,
            UTMSource: "ORGANIC",
            source: getDevice()
        };
        const onSucess = (res) => {
            // makeToast("success", msg);
            setLoder(false);
            console.log(res);

            if (res.status == 200 || res.status == 201) {

                console.log("it works")
                if (subject !== ":component") {
                    localStorage.setItem("SUBJECT", JSON.stringify(subject));
                }

                localStorage.setItem("LOGIN", JSON.stringify("true"));
                localStorage.setItem("ROLE", JSON.stringify("Learner"));
                localStorage.setItem("IS_LOGOUT", true);
                localStorage.setItem("LOGIN", JSON.stringify("true"));
                localStorage.setItem("ROLE", JSON.stringify("Learner"));
                localStorage.setItem("USER", JSON.stringify(res.data.learner));
                localStorage.setItem("TOKEN", JSON.stringify(res.data.learner.token));
                localStorage.setItem("IS_LOGOUT", true);
                localStorage.removeItem("STEP");
                localStorage.removeItem("DATA");
                localStorage.removeItem("NAME");
                openSnackbar("successful");

                history.push(`/home-subscription/payment?type=${subscriptionType}`);
                // window.location.reload();

            }

            else if (res.status == 201) {
                console.log("user exist")
                console.log(res)
                setStatusCode(res.status);
                setIswhatsapp(res.data.learner.isWhatsappNumber);
                setIsnumber(res.data.learner.phoneNumber);
                setIsemail(res.data.learner.email);


                history.push(`/home-subscription/payment?type=${subscriptionType}`);

                // history.push("/login");

            }

        };
        const onError = (res) => {
            //   setField("password");
            setLoder(false);
            setErrmsg("Enter a valid number");
            openSnackbar("Enter a valid number")

            console.log(res)
        };
        dispatch(SignupWithoutOtp(data, onSucess, onError));
    };

    //askOTP
    const askforOtp = () => {
        // ResendOtp
        if (numberOremail) {
            const data = {
                phoneNumber: numberOremail,
            };
            const onSuccess = () => {
                openSnackbar("OTP sent Successfully");
            };

            const onError = (msg) => {
                openSnackbar(msg);
            };
            dispatch(AskOtp(data, onSuccess, onError));
        } else {
            openSnackbar("something went wrong");
        }
    };

    //resend OTP
    const resendOtp = () => {
        // ResendOtp
        if (numberOremail) {
            const data = {
                phoneNumber: numberOremail,
            };
            const onSuccess = () => {
                openSnackbar("OTP sent Successfully");
            };

            const onError = (msg) => {
                openSnackbar(msg);
            };
            dispatch(ResendOtp(data, onSuccess, onError));
        } else {
            openSnackbar("Please Enter Phone number or Email");
        }
    };

    useEffect(() => {
        if (statusCode == 201) {
            askforOtp();
        }
    }, [statusCode]);

    //verifyotp

    const verifyOTP = (e) => {
        e.preventDefault();
        setLoder(true);

        var data = {
            OTP: otp,

        };


        const onSuccess = (res) => {
            console.log(res);
            openSnackbar(res.data.message);
            setLoder(false);
            localStorage.removeItem("IS_LOGOUT");
            localStorage.setItem("USER", JSON.stringify(res.data.learner));
            localStorage.setItem("TOKEN", JSON.stringify(res.data.learner.token));
            localStorage.setItem("LOGIN", JSON.stringify("true"));
            localStorage.setItem("IS_LOGOUT", JSON.stringify(true));
            localStorage.setItem("ROLE", JSON.stringify("Learner"));

            history.push("/dashboard");
            // window.location.reload();
            // history.push("/dashboard");

        };
        const onError = (msg) => {
            setField("otp");
            openSnackbar(msg);
            setLoder(false);
            setErrmsg(msg);
        };


        dispatch(VerifyOtp(data, onSuccess, onError));


    };

    return (
        <div className="bookdemo-root ">
            <div className="container">
                <div className="bookdemo">
                    <div className="steps">
                        <div className="steps-flex">
                            <p className="step1" style={{ fontWeight: "bolder", color: "#24A15C" }}>STEP-1</p>
                            <p className="step2" style={{ fontWeight: "bolder" }}>STEP-2</p>
                            <p className="step3" style={{ fontWeight: "bolder" }}>STEP-3</p>
                        </div>
                        <ProgressBar
                            percent={10}
                            filledBackground="linear-gradient(to right, #24A15C, #44E18C)"
                        />
                    </div>


                    <div>

                       

                            {subscriptionType === "kids" ?

                                <form onSubmit={(e) => signupwithoutotpkids(e)}>

                                    <div className="demo-form">
                                        <div className="form-group mt-3">
                                            <label >

                                                <div className="mb-2">
                                                    {/* <img width="122px" height="32px" src={demologo} alt="clapingologo" /> */}
                                                    <img src={demologo} width="122px" height="32px" />
                                                </div>
                                                <p
                                                    className="headingfont"
                                                >
                                                    Book a Trial
                                                </p>
                                                {/* <p className="subtitle">Book your 15 min. trial @ {time_zone.timezone == "Asia/Calcutta" || time_zone.timezone == "Asia/Kolkata" ? "₹99." :"$1.99"}</p> */}
                                            </label>

                                            <div className="form-row">
                                                <div className="col">
                                                    <label>Name</label>
                                                    <input
                                                        id="fname"
                                                        type="text"
                                                        className="form-control RegInput "
                                                        placeholder="Full name"
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                                <div className="col">

                                                </div>

                                            </div>
                                            <div className="form-row mt-2">
                                                <div className="col">
                                                    <label htmlFor="parent">Grade</label>
                                                    <select
                                                        className="form-control RegInput"
                                                        value={grade}
                                                        onChange={(e) => setGrade(e.target.value)}
                                                        aria-label="Select grade"
                                                    >
                                                        <option selected>Select grade</option>
                                                        <option value="1">1</option>
                                                        <option value="2">2</option>
                                                        <option value="3">3</option>
                                                        <option value="4">4</option>
                                                        <option value="5">5</option>
                                                        <option value="6">6</option>
                                                        <option value="7">7</option>
                                                        <option value="8">8</option>
                                                        <option value="9">9</option>
                                                        <option value="10">10</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-row mt-3">

                                                <div className="col">

                                                    <label>Phone Number</label>

                                                    <PhoneInput
                                                        placeholder="Enter Mobile number"
                                                        className="form-control RegInput d-flex"
                                                        international
                                                        countryCallingCodeEditable={false}
                                                        defaultCountry={time_zone.country}
                                                        // country={time_zone.country}
                                                        value={internationalNumber}
                                                        onChange={setInternationalNumber}
                                                        disabled={disabledNumber}
                                                        required

                                                    />

                                                </div>
                                                <div className="col mt-3">
                                                    <div className="phoneinput">
                                                        <label>Email Id</label>
                                                        <input
                                                            id="cityfield"
                                                            type="email"
                                                            className="form-control RegInput"
                                                            placeholder="abc@gmail.com"
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                            </div>


                                            <p className="error text-center mt-2" style={{ color: "red" }}>{errmsg}</p>

                                            <div className="text-center">
                                                <button
                                                    type="submit"
                                                    // onClick={()=>history.replace({ pathname: 'schedule-demo'})}
                                                    disabled={loder ? true : false}

                                                    className={loder ? "continueBTNdisabled btn-block mx-auto mt-5" : "continueBTN btn-block  mx-auto mt-5"}

                                                >
                                                    {loder ? (
                                                        "Loading ..."
                                                    ) : (
                                                        "Book a Trial"
                                                    )}
                                                </button>
                                            </div>
                                            {/* <p className="text-center mt-1 text-danger">{errormsg}</p> */}


                                        </div>
                                    </div>
                                </form>
                                :
                                <form onSubmit={(e) => signupwithoutotp(e)}>

                                    <div className="demo-form">
                                        <div className="form-group mt-3">
                                            <label >

                                                <div className="mb-2">
                                                    <img width="122px" height="32px" src={demologo} alt="clapingologo" />
                                                </div>
                                                <p
                                                    className="headingfont"
                                                >
                                                    Subscribe to Clapingo
                                                </p>
                                                {/* <p className="subtitle">Book your 15 min. trial @ {time_zone.timezone == "Asia/Calcutta" || time_zone.timezone == "Asia/Kolkata" ? "₹99." :"$1.99"}</p> */}
                                            </label>

                                            <div className="form-row">
                                                <div className="col">
                                                    <label>Name</label>
                                                    <input
                                                        id="fname"
                                                        type="text"
                                                        className="form-control RegInput "
                                                        placeholder="Full name"
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                        required
                                                    />
                                                </div>


                                            </div>
                                            <div className="form-row mt-3">

                                                <div className="col">

                                                    <label>Phone Number</label>

                                                    <PhoneInput
                                                        placeholder="Enter Mobile number"
                                                        className="form-control RegInput d-flex"
                                                        international
                                                        countryCallingCodeEditable={false}
                                                        defaultCountry={time_zone.country}
                                                        // country={time_zone.country}
                                                        value={internationalNumber}
                                                        onChange={setInternationalNumber}
                                                        disabled={disabledNumber}
                                                        required

                                                    />

                                                </div>
                                                <div className="col ">
                                                    <div className="phoneinput">
                                                        <label>Email id</label>
                                                        <input
                                                            id="cityfield"
                                                            type="email"
                                                            className="form-control RegInput"
                                                            placeholder="abc@gmail.com"
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                            </div>


                                            <p className="text-center mt-2" style={{ color: "red" }}>{errmsg}</p>

                                            <button
                                                type="submit"
                                                // onClick={()=>history.replace({ pathname: 'schedule-demo'})}
                                                disabled={loder ? true : false}

                                                className={loder ? "continueBTNdisabled btn-block mx-auto mt-5" : "continueBTN btn-block  mx-auto mt-5"}

                                            >
                                                {loder ? (
                                                    "Loading ..."
                                                ) : (
                                                    "Proceed to Payment"
                                                )}
                                            </button>

                                            {/* <p className="text-center mt-1 text-danger">{errormsg}</p> */}


                                        </div>
                                    </div>
                                </form>

                        }


                    </div>

                </div></div></div>

    )
}

export default DemoRegister;
